import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLink} from 'apollo-link-http';
import {ApolloLink} from 'apollo-link';
import {setContext} from 'apollo-link-context';
import {setUserPrimeData} from '../redux/actions/Util';
import {store} from '../redux/store';

const httpLink = new HttpLink({
  uri: 'https://services-new.medcampus.io/query',
});

const authMiddleware = setContext(async () => {
      let accessToken = localStorage.getItem('auth-token');
      if (accessToken !== null) {
        return ({
          headers: {
            'X-Auth-Token': localStorage.getItem('auth-token'),
            'X-Refresh-Token': localStorage.getItem('refresh-token'),
            'X-CSRF-Token': localStorage.getItem('csrf-key'),
          },
        });
      } else return '';
    },
);

const afterwareLink = new ApolloLink((operation, forward) =>
    forward(operation).map(response => {
      if (response.errors !== undefined && response.errors.length > 0) {
        if (response.errors[0] && response.errors[0].extensions &&
            response.errors[0].extensions.code === 'UNAUTHENTICATED') {
          localStorage.clear();
          window.location.reload();
        }
      }
      const {response: {headers}} = operation.getContext();
      if (headers) {
        const authToken = headers.get('X-Auth-Token');
        const refreshToken = headers.get('X-Refresh-Token');
        const csrfToken = headers.get('X-CSRF-Token');

        if (authToken) {
          localStorage.setItem('auth-token', authToken);
          store.dispatch(setUserPrimeData(authToken));
        }
        if (refreshToken) {
          localStorage.setItem('refresh-token', refreshToken);
        }
        if (csrfToken) {
          localStorage.setItem('csrf-key', csrfToken);
        }
      }
      return response;
    }),
);

const link = ApolloLink.from([authMiddleware, afterwareLink, httpLink]);

const cache = new InMemoryCache();
export const client = new ApolloClient({
  link,
  cache,
});

client.defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};
